module.exports = __webpack_public_path__ + "static/media/customer-9.cc866c53.jpg";